<template>
  <div
    ref="containerRef"
    class="container-fluid container-xxl d-flex flex-column align-items-center justify-content-between min-vh-100 vw-100 bg-success p-4 overflow-hidden flex-grow-1"
  >
    <div class="w-100 d-flex justify-content-end">
      <button
        id="close-btn"
        @click="close()"
        class="text-white fw-bolder border-0 bg-transparent float-end"
      >
        &times;
      </button>
    </div>

    <h2 class="text-white text-center fs-4 fw-bold mt-5">
      {{ t("TRANSITIONAL_VIEW_TITLE") }}
    </h2>

    <div class="position-relative d-flex justify-content-center w-100 mt-5">
      <img
        :src="useAsset('img/credit-line/super-pacman-welcome.svg')"
        alt="Cards"
        class="w-100 mw-sm-100"
      />
    </div>

    <section
      class="w-100 d-flex flex-column align-items-center gap-3 mt-auto mb-0"
    >
      <router-link :to="{ name: 'CreditCardDetailsView' }" class="link">
        <button class="text-white py-2 px-4 rounded border-0">
          {{ t("GO_TO_PHYSICAL_CARD") }}
        </button>
      </router-link>
      <router-link :to="{ name: 'CreditCardConfirmCreateView' }" class="link">
        <button class="text-white border-0 bg-transparent">
          {{ t("GO_TO_VIRTUAL_CARD") }}
        </button>
      </router-link>
    </section>
  </div>
</template>

<script setup lang="ts">
import useAsset from "@/apps/credit-line/helpers/useAsset";
import { useI18n } from "@/apps/credit-line/composables/useI18n";
import { onMounted, ref } from "vue";
import { AndroidInterface } from "@/apps/credit-line/services/android.service";
import { AndroidFinishLoadingHelper } from "@/apps/credit-line/helpers/androidFinishLoading.helper";

declare const Android: AndroidInterface;

const { t } = useI18n();

const containerRef = ref();

const close = (): void => {
  Android.dismissWebView();
};

onMounted(() => {
  (containerRef.value as HTMLElement).style.height = window.innerHeight + "px";
  AndroidFinishLoadingHelper();
});
</script>

<style scoped lang="scss">
html,
body {
  height: 100%;
  margin: 0;
  padding: 0;
  overflow: hidden;
  color: white;
  text-decoration: none;
}

h2 {
  font-feature-settings: "liga" off, "clig" off;
  font-family: Inter, serif;
}

#close-btn {
  padding: 0;
  margin: -1rem 1rem 0 0;
  width: 2px;
  height: 2px;
  font-size: 2rem;
}

section {
  & .link {
    width: 100%;
    font-feature-settings: "liga" off, "clig" off;
    font-family: Inter, serif;
  }

  & button {
    border-radius: 0.3125rem;
    background: #8bc53f;
    width: 100%;
    height: 3rem;
    font-feature-settings: "liga" off, "clig" off;
    font-family: Inter, serif;
    font-size: 1rem !important;
    font-style: normal;
    font-weight: 600;
  }

  &:last-child {
    background: transparent;
  }
}
</style>
